import cx from 'classnames';
import {
  BellMinus,
  Car,
  CircleDot,
  ClipboardCheck,
  Cog,
  Droplet,
  Search,
  ShieldCheck,
  Thermometer,
  Zap
} from 'lucide-react';
import serviceCapabilityGroups from '~/constants/dealership/serviceCapabilities';
import styles from './ServiceCapabilities.module.css';

const iconMap: Record<
  string,
  React.ComponentType<{ size: number; className?: string }>
> = {
  BellMinus,
  Car,
  Circle: CircleDot,
  ClipboardCheck,
  Cog,
  Droplet,
  Search,
  ShieldCheck,
  Thermometer,
  Zap
};

export default function ServiceCapabilities() {
  return (
    <section className="bg-canvas-muted px-lg py-4xl md:px-2xl md:py-[96px]">
      <div className="mx-auto max-w-[1272px]">
        <div className="mx-auto max-w-[720px] text-center">
          <div className="mb-lg text-text-primary t-label-xs tracking-widest">
            OUR SERVICE CAPABILITIES
          </div>
          <h2 className="mb-lg text-text-strong t-heading-3xl">
            Everything your vehicle needs, under one roof.
          </h2>
          <p className="text-text-default t-body-lg">
            Routine maintenance to complex repairs — for Chrysler, Dodge, Jeep,
            Ram, FIAT, and all other makes and models.
          </p>
        </div>

        <div className="mt-3xl grid grid-cols-1 gap-2xl md:mt-4xl md:grid-cols-3">
          {serviceCapabilityGroups.map((group, i) => (
            <div
              key={group.title}
              className={cx(
                'relative overflow-hidden rounded-xl border border-border-subtle bg-canvas-default p-2xl',
                styles[group.accentClass]
              )}
            >
              <div
                className={cx(
                  'absolute left-0 right-0 top-0 h-[4px]',
                  styles.accentBar
                )}
              />

              <div
                className={cx(
                  'mb-xs t-label-xs tracking-widest',
                  styles.accentNumber
                )}
              >
                {String(i + 1).padStart(2, '0')}
              </div>

              <h3 className="mb-2xl text-text-strong t-heading-lg">
                {group.title}
              </h3>

              <div className="flex flex-col gap-[14px]">
                {group.items.map((capability, j) => {
                  const Icon = iconMap[capability.iconName] ?? Cog;

                  return (
                    <div
                      key={capability.label}
                      className={cx('flex items-center gap-[14px] py-xs', {
                        'border-t border-dashed border-border-subtle pt-lg':
                          j > 0
                      })}
                    >
                      <div className="flex size-[36px] shrink-0 items-center justify-center rounded-[10px] bg-canvas-muted">
                        <Icon size={18} className={styles.accentNumber} />
                      </div>
                      <span className="text-text-strong t-strong-sm">
                        {capability.label}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
